$(function () {
    if ($("#adjustments-form").length > 0) {

        $(':radio').each(function () {
            $(this).removeAttr('checked');
            $('input[type="radio"]').prop('checked', false);
        })

        function calcTotals() {
            var amount = parseFloat(parseFloat($('#AmountText').val().toString().replace(",", ".")).toFixed(2));

            if (amount > 10000000) {
                amount = 10000000;
            }

            if (isNaN(amount)) {
                // if no input, just show zero
                $('#TotalText').val(pre + '0.00'.replace('.', decimalValue) + post);
            } else {
                $('#AmountText').val(('' + amount).replace('.', decimalValue));
                var admin = parseFloat($('#AdminPercent').val().toString().replace(",", "."));

                var total = parseFloat(amount + (amount * admin)).toFixed(2).replace('.', decimalValue);
                var adminAmount = parseFloat((amount * admin)).toFixed(2).replace('.', decimalValue);

                if ($("input[name='NegativePositive']:checked").val() == 0) {
                    // is negative
                    $('#TotalText').val(pre + '(' + total + ')' + post);

                    $('.confirm-amount').html(pre + '(' + amount.toFixed(2).replace('.', decimalValue) + ')' + post);
                    $('.confirm-admin').html(pre + '(' + adminAmount + ')' + post);
                    $('.confirm-total').html(pre + '(' + total + ')' + post);
                } else {
                    // is positive
                    $('#TotalText').val(pre + total + post);

                    $('.confirm-amount').html(pre + amount.toFixed(2).replace('.', decimalValue) + post);
                    $('.confirm-admin').html(pre + adminAmount + post);
                    $('.confirm-total').html(pre + total + post);
                }
            }
        }




        $("#ProgramTypeCd").on('change', function () {
            window.location = $("#adjustments-form").attr('action') + '?pt=' + $("#ProgramTypeCd").val();
        });

        if (pt != 1) {
            $("#AdminPercent").val(0);
            $(".aa").addClass("d-none");
        } else {
            $("#AdminPercent").val(0.14);
            $(".aa").removeClass("d-none");
        }

        $("#AmountText").on('blur', function () {
            calcTotals();
        });

        $("#AdminPercent").on('change blur', function () {
            calcTotals();
        });


        $("input[name='NegativePositive']").on('change blur focus', function () {
            if ($('#Positive').is(':checked')) {
                $("input[name='NegativePositive']:checked").val(1);
            }

            if ($("input[name='NegativePositive']:checked").val() == 1) {
                $("#AdjustmentApplyToTypeCd option[value='2']").prop('disabled', false);
                if ($("#AdjustmentApplyToTypeCd").val() == 2) {
                    $("#AdjustmentApplyToTypeCd").val(1);
                }
            } else {
                $("#AdjustmentApplyToTypeCd option[value='2']").prop('disabled', true);
            }
            calcTotals();
        });

        $("input[name='NegativePositive']").change();

        $(".btnSubmit").on('click', function () {
            $("#confirmModal").modal('hide');
            $("#adjustments-form")[0].submit();
        });

        $(".btnCancelSubmit").on('click', function () {
            $("#cancelModal").modal('hide');
            $("#form2")[0].submit();
        });

        $("input.number").on("keydown", function (e) {
            // allow function keys and decimal separators
            if (
                // backspace, delete, tab, escape, enter, comma and .
                $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 188, 190]) !== -1 ||
                // Ctrl/cmd+A, Ctrl/cmd+C, Ctrl/cmd+X
                ($.inArray(e.keyCode, [65, 67, 88]) !== -1 && (e.ctrlKey === true || e.metaKey === true)) ||
                // home, end, left, right
                (e.keyCode >= 35 && e.keyCode <= 39)) {

                /*
                // optional: replace commas with dots in real-time (for en-US locals)
                if (e.keyCode === 188) {
                    e.preventDefault();
                    $(this).val($(this).val() + ".");
                }

                // optional: replace decimal points (num pad) and dots with commas in real-time (for EU locals)
                if (e.keyCode === 110 || e.keyCode === 190) {
                    e.preventDefault();
                    $(this).val($(this).val() + ",");
                }
                */

                return;
            }
            // block any non-number
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });

        $(".btnShowConfirm").on('click', function () {
            if ($("#adjustments-form").valid()) {
                $("#confirmModal").modal('show');
            }
        });


        $(".btnShowCancel").on('click', function () {
            if ($("#form2").valid()) {
                $(".confirm-reason").html($("#CancelVM_AdjustmentCancelReasonTypeCd option:selected").text());
                $("#cancelModal").modal('show');
            }
        });


        $("#AdminPercent").rules("remove", "number");
        $("#TotalText").rules("remove", "number");
        $("#AmountText").rules("remove", "number");

        calcTotals();


    }
});